export function getBase64(file, callback) {
  console.log(file)

  let reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    callback(reader.result)
  };
  reader.onerror = function (error) {
    console.log('Error: ', error);
  };
}
